var map = {
	"./demos/basic/index.ts": 47408,
	"./demos/beforeChange/index.ts": 76138,
	"./demos/closable/index.ts": 12630,
	"./demos/custom/index.ts": 7937,
	"./demos/customText/index.ts": 49384,
	"./demos/declarative/index.ts": 58957,
	"./demos/events/index.ts": 25284,
	"./demos/maskClosable/index.ts": 86529,
	"./demos/notarget/index.ts": 76351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31715;